





















































































































































import Vue from "vue";
import { Prop, Component, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Site } from "@/shared/Site";
import GraphData, {
  DataSet,
  ChartOptions,
  MyOptions,
} from "@/charts/graphData";
import MobileMixin from "@/mixins/mobileMixin";
import jsonURL from "@/shared/urls";
import moment from "moment/moment";
import NumberTmpl from "@/ui-component/number.vue";
import axios from "@/plugins/axios";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class Top10 extends mixins(MobileMixin) {
  public dataGetted = false;
  public products: any = [];
  public config: any;
  public titre = "";
  public topMontant = true;
  public unfilteredObj: any = [];
  public showFullList = false;
  @Prop() public myOptions!: MyOptions;

  public mounted() {
    moment.locale("fr");
    // this.init();
  }

  @Watch("myOptions", { immediate: true, deep: true })
  public onPropertyChanged(value: any, oldValue: any) {
    if (this.myOptions && this.myOptions.site !== undefined) {
      this.init();
    }
  }

  public init() {
    this.config = {
      site: this.myOptions.site[0],
      periode: this.myOptions.periode,
      date: moment().format("YYYY-MM-DD"),
    };
    this.updateWs();
    // this.orderConfig();
    this.getData();
  }

  public filteredProducts() {
    return this.products.slice(3, 10);
  }

  public filteredProductsFull() {
    return this.products.slice(0, 10);
  }

  public updateFilter() {
    const myarray = Array.from(this.unfilteredObj);
    if (this.topMontant) {
      this.products = myarray.sort((p1: any, p2: any) => {
        return parseFloat(p2.montant) - parseFloat(p1.montant);
      });
    } else {
      this.products = myarray.sort((p1: any, p2: any) => {
        return p2.nombre - p1.nombre;
      });
    }
  }

  public getSwitchLabel() {
    return this.topMontant
      ? this.$t("Montant").toString()
      : this.$t("Nombre").toString();
  }

  public showMeMore() {
    this.showFullList = true;
  }

  private updateWs() {
    const dateFormat = "YYYY-MM-DD";
    // console.log(this.periode);
    switch (this.myOptions.periode) {
      case "J":
        this.config.dateDebut = moment(this.myOptions.date).format(dateFormat);
        this.config.dateFin = moment(this.myOptions.date).format(dateFormat);
        break;
      /*case "SEMAINE":
            this.config.WSttc =  jsonURL.updateCASurSemaine;
            this.config.WSht = jsonURL.updateCaHTSurAujourdhui;
            break;*/
      case "MOIS":
        this.config.dateDebut = moment(this.myOptions.date)
          .startOf("month")
          .format(dateFormat);
        this.config.dateFin = moment(this.myOptions.date)
          .endOf("month")
          .format(dateFormat);
        break;
      case "ANNEE":
        this.config.dateDebut = moment(this.myOptions.date)
          .startOf("year")
          .format(dateFormat);
        this.config.dateFin = moment(this.myOptions.date)
          .endOf("year")
          .format(dateFormat);
        break;
    }
  }
  /**
   *
   */
  private async getData() {
    // console.log("getData");
    this.dataGetted = false;
    this.updateWs();
    const user = JSON.parse(localStorage.user);
    const userId = user.id;
    const url = `bo/getReport?id=${userId}&rapportClassName=eu.cashsystemes.starmanager.bk.rapports.report.divers.AnalyseProduitsReport&typeRapport=BK&dateDebut=${this.config.dateDebut}&dateFin=${this.config.dateFin}&operation=VENTE&format=CSV&trancheHoraire=false&sites[]=${this.config.site.libelle}`;
    await axios
      .get(url)
      .then(
        (response) => {
          this.csvToArray(response.data);
        },
        (error) => {
          throw new Error(JSON.stringify(error));
        }
      )
      .catch((error) => {
        const myerror = { message: error.message, status: error.status, error };
        throw new Error(JSON.stringify(myerror));
      });
  }

  private csvToArray(rows: any) {
    const arr = rows.split("\n");
    if (arr.length === 2) {
      return;
    }
    const jsonObj = [];
    let headers = arr[0].split(";");
    headers = headers.map((des: string) => des.toLowerCase());
    for (let i = 1; i < arr.length; i++) {
      const data = arr[i].split(";");
      const obj: any = {};
      for (let j = 0; j < data.length; j++) {
        const val = data[j].replaceAll("\"", "").trim();
        obj[headers[j].trim()] = val;
      }
      jsonObj.push(obj);
    }
    this.dataGetted = true;
    this.unfilteredObj = jsonObj;
    this.updateFilter();
  }
}
